"use client";
import i, { createContext as d, useReducer as g, useEffect as v, useDebugValue as R, useCallback as b, useContext as w } from "react";
import { g as S } from "./vanilla-CSAfDK5R.js";
var _ = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const h = d(
  void 0
), a = (e) => w(h) || S(), A = (e) => typeof (e == null ? void 0 : e.then) == "function", D = i.use || ((e) => {
  if (e.status === "pending")
    throw e;
  if (e.status === "fulfilled")
    return e.value;
  throw e.status === "rejected" ? e.reason : (e.status = "pending", e.then(
    (n) => {
      e.status = "fulfilled", e.value = n;
    },
    (n) => {
      e.status = "rejected", e.reason = n;
    }
  ), e);
});
function E(e, n) {
  const t = a(), [[c, o, f], r] = g(
    (u) => {
      const l = t.get(e);
      return Object.is(u[0], l) && u[1] === t && u[2] === e ? u : [l, t, e];
    },
    void 0,
    () => [t.get(e), t, e]
  );
  let s = c;
  return (o !== t || f !== e) && (r(), s = t.get(e)), v(() => {
    const u = t.sub(e, () => {
      r();
    });
    return r(), u;
  }, [t, e, void 0]), R(s), A(s) ? D(s) : s;
}
function x(e, n) {
  const t = a();
  return b(
    (...o) => {
      if ((_ ? "production" : void 0) !== "production" && !("write" in e))
        throw new Error("not writable atom");
      return t.set(e, ...o);
    },
    [t, e]
  );
}
function y(e, n) {
  return [
    E(e),
    // We do wrong type assertion here, which results in throwing an error.
    x(e)
  ];
}
export {
  x as a,
  y as b,
  E as u
};
//# sourceMappingURL=react-B_GApDuV.js.map
